var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoFasciaJd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15.999,
    viewBox: "0 0 16 15.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Logo-Fascia-JD",
    transform: "translate(-22 -5)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Base",
    d: "M30 5a8 8 0 1 0 8 8 8 8 0 0 0-8-8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "prefix__JD",
    d: "M35.675 14.28a2.981 2.981 0 0 1 2.361.969 3.451 3.451 0 0 1 .643 2.808 4.311 4.311 0 0 1-4.222 3.74h-2.588l.011-.069 1.23-7.449zm-.742 1.752c-.134 0-.237.007-.292.012l-.65 3.944a3.077 3.077 0 0 0 .314.016 2.3 2.3 0 0 0 2.479-2 1.659 1.659 0 0 0-.265-1.4 2.11 2.11 0 0 0-1.586-.571zm-7.512 5.989a1.671 1.671 0 0 1-.28-.019l-.055-.01.245-1.881h.079c2.74 0 3.242-5.706 3.247-5.764v-.056h1.889l-.01.068c-1.056 7.107-4.187 7.66-5.121 7.66",
    transform: "translate(-2.825 -5.156)",
    style: {
      fill: "#fff"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFasciaJd);
export default __webpack_public_path__ + "static/media/logo-fascia-jd.235cf2a3.svg";
export { ForwardRef as ReactComponent };